import { useField } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { composeValidators, selectRequired } from '../../utilities/validate'
import { UseTimePickerProps as Props } from './timepickerType'
import useTranslate from '../../i18n/useTranslate'

export type UseTimePickerProps = Props

const useTimepicker = ({ name, required, validates = [] }: UseTimePickerProps) => {
    let mergeValidate: FieldValidator<any>[] = validates
    const translate = useTranslate()
    const needRequired = typeof required === 'boolean' ? required : !!required?.triggedValidate

    if (needRequired) {
        const reqValidator: FieldValidator<any> = selectRequired(
            typeof required === 'object' ? required?.errorMessage : translate.get('MESSAGE.M016'),
        )
        mergeValidate = [reqValidator, ...mergeValidate]
    }

    const field = useField<string | undefined>(name, {
        validate: composeValidators(...mergeValidate),
    })

    return { field }
}

export default useTimepicker
